import { render } from "./TheNavbarMessages.pug?vue&type=template&id=12a85f68&lang=pug"
import script from "./TheNavbarMessages.js?vue&type=script&lang=js"
export * from "./TheNavbarMessages.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__